import { render, staticRenderFns } from "./userPortrait.vue?vue&type=template&id=27b12c20&scoped=true&"
import script from "./userPortrait.vue?vue&type=script&lang=js&"
export * from "./userPortrait.vue?vue&type=script&lang=js&"
import style0 from "./userPortrait.vue?vue&type=style&index=0&id=27b12c20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b12c20",
  null
  
)

component.options.__file = "userPortrait.vue"
export default component.exports